import React from "react";
import { cn } from "@/lib/utils";

export function LogoMark({ className }) {
  return (
    <img
      src="/logo.jpeg"
      alt="Pack Mate"
      className={cn("w-9 h-9 rounded-xl object-cover shadow-sm", className)}
    />
  );
}

export function BrandLogo({ className, textClassName }) {
  return (
    <span className={cn("flex items-center gap-2", className)}>
      <LogoMark />
      <span className={cn("text-lg font-bold font-heading text-slate-900", textClassName)}>Pack Mate</span>
    </span>
  );
}
